export const vacationDescConstants = {
    UPDATE_VACATION_DESC: '[VacationDesc] Update',
    REMOVE_VACATION_DESC: '[VacationDesc] Remove',
    LOADING_VACATION_DESC: '[VacationDesc] Loading',
    LOADING_VACATION_DESC_ERROR: '[VacationDesc] Loading error',
    VACATION_DESC_AJAX_CALL: '[VacationDesc] Ajax call',
    VACATION_DESC_AJAX_SUCCESS: '[VacationDesc] Ajax success',
    VACATION_DESC_AJAX_FAILURE: '[VacationDesc] Ajax error'
}
